import React from 'react'
import { GridCell } from 'common-controls/Core/index'

import styles from './ViewLayout.less'

export function ViewLayoutHeader (props) {
  const { children, blue } = props
  const color = blue ? 'blue' : 'teal'

  return (
    <GridCell shrink className={`slide-pane-head-${color}` + ' ' + styles.marginBottom0}>
      {children}
    </GridCell>
  )
}

export default ViewLayoutHeader
